import React, { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { MarginProps } from '../../../../../theme/styledProps';
import { FormValues } from '../../FirmSettings.meta';
import { ManageSignaturePageModal } from '../../../../../ManageSignaturePageModal/ManageSignaturePageModal';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const SignaturePage = ({ formBag, ...rest }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { setValue, watch } = formBag;

  const allowSignaturePage = watch('allowSignaturePage');
  const signaturePage = watch('signaturePage');
  const allowAdvisersOverrideSignaturePage = watch('allowAdvisersOverrideSignaturePage');

  return (
    <>
      <Box as="section" {...rest}>
        <SectionHeader title="Ability to Edit Signature Page" />

        <Toggle
          checked={allowSignaturePage}
          onChange={evt => {
            setValue('allowSignaturePage', evt.target.checked, { shouldDirty: true });
          }}
          helperText={
            allowSignaturePage ? (
              <Button
                type="button"
                variant="link"
                size="small"
                ml={2}
                onClick={evt => {
                  evt.preventDefault();
                  setIsModalOpen(true);
                }}
              >
                Manage Signature Page
              </Button>
            ) : (
              ''
            )
          }
        >
          Allow the Ability to Edit Signature Page
        </Toggle>
      </Box>

      {isModalOpen && (
        <ManageSignaturePageModal
          isOpen={isModalOpen}
          mode="firm"
          content={signaturePage}
          allowAdvisersOverrideSignaturePage={allowAdvisersOverrideSignaturePage}
          onClose={() => setIsModalOpen(false)}
          onChange={({ content, allowAdvisersOverrideSignaturePage: allowOverride }) => {
            setValue('signaturePage', content, { shouldDirty: true });

            if (allowOverride !== undefined) {
              setValue('allowAdvisersOverrideSignaturePage', allowOverride, { shouldDirty: true });
            }
          }}
        />
      )}
    </>
  );
};
